// extracted by mini-css-extract-plugin
export default {"navItem":"navigationItem__navItem--AjIU7","link":"navigationItem__link--aXiOj"};